export const AutoVINField = (value) => {
    if (value.length != 17) {
        return {
            status: false,
            msg: 'Seria de șasiu trebuie sa aibă 17 caractere',
        }
    }
    else {
        return {
            status: true,
            msg: ''
        }
    }
}


export const CarRegistrationField = (value, params) => {
    const {tip_inmatriculare} = params;
    if (tip_inmatriculare == 'inmatriculat') {
        if (value.length == 0) {
            return {
                status: false,
                msg: 'Completează câmpul',
            }
        } else if (value.length<6) {
            return {
                status: false,
                msg: 'Număr de înmatriculare incorect',
            }
        }
    }
    return {
            status: true,
            msg: ''
        }
}

export const CarDateRegistrationField = (value, params) => {
    const {tip_inmatriculare} = params;
    if (tip_inmatriculare == 'inmatriculat') {
        if (value.length == 0) {
            return {
                status: false,
                msg: 'Completează câmpul',
            }
        }
    }
    return {
            status: true,
            msg: ''
        }
}

export const CarDateITPField = (value, params) => {
    const {tip_inmatriculare} = params;
    if (tip_inmatriculare == 'inmatriculat') {
        if (value.length == 0) {
            return {
                status: false,
                msg: 'Completează câmpul',
            }
        }
    }
    return {
            status: true,
            msg: ''
        }
}


export const ProductionYear = (val) => {
    let year = new Date().getFullYear(); 
    if (val == '') {
        return {
            status: false,
            msg: 'Completeză cămpul',
        }
    }
    
    if ((val.toString().length !=4) || (val>(year+1)) || (val<1930) ) {
        return {
            status: false,
            msg: 'Valoare incorectă',
        }
    }

    return  {
            status: true,
            msg: ''
        }  
}

export const CIVField = (val) => {
    if (val == '') {
        return {
            status: false,
            msg: 'Completeză cămpul',
        }
    }
    if (val.length == 7) {
        return {
            status: true,
            msg: '',
        }
    }

    return  {
            status: false,
            msg: 'Valoare incorectă',
        }  
}

export const SerieCIField = (val) => {
    if (val == '') {
        return {
            status: false,
            msg: 'Completeză cămpul',
        }
    } 
    else if ( /\d/.test(val)) {
        return {
            status: false,
            msg: 'Completează doar litere',
        }
    }

    if (val.length == 2) {
        return {
            status: true,
            msg: '',
        }
    }

    return  {
            status: false,
            msg: 'Valoare incorectă',
        }  
}

export const NumarCIField = (val) => {
    if (val == '') {
        return {
            status: false,
            msg: 'Completeză cămpul',
        }
    } 
    else if ( ! /\d/.test(val)) {
        return {
            status: false,
            msg: 'Completează doar cifre',
        }
    }

    if (val.length == 6 || val.length == 7) {
        return {
            status: true,
            msg: '',
        }
    } else {
        return {
            status: false,
            msg: 'Câmpul trebuie să aibă 6 sau 7 cifre',
        }
    }  
}

export const postalCodeValidator = (val) => {
    if (val == '') {
        return {
            status: false,
            msg: 'Completeză cămpul',
        }
    } 
    else if ( ! /\d/.test(val)) {
        return {
            status: false,
            msg: 'Completează doar cifre',
        }
    }

    if (val.length == 6 || val.length == 7) {
        return {
            status: true,
            msg: '',
        }
    } else {
        return {
            status: false,
            msg: 'Câmpul trebuie să aibă 6 sau 7 cifre',
        }
    }  
}

export const AnPermisField = (val) => {
    let year = new Date().getFullYear(); 
    if (val == '') {
        return {
            status: false,
            msg: 'Completeză cămpul',
        }
    }
    
    if ((val.toString().length !=4) || (val>year) || (val<1930) ) {
        return {
            status: false,
            msg: 'Valoare incorectă',
        }
    }

    return  {
            status: true,
            msg: ''
        }  
}